var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_18_clients2_px24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M563.245,1335.259a11.19,11.19,0,0,0-2.572-3.6,11.862,11.862,0,0,0-3.814-2.431.045.045,0,0,0-.038-.013,7.37,7.37,0,0,0,3.282-6.071,7.928,7.928,0,0,0-15.829,0,7.369,7.369,0,0,0,3.28,6.071.046.046,0,0,0-.038.013,11.906,11.906,0,0,0-3.814,2.431,11.213,11.213,0,0,0-2.572,3.6,10.627,10.627,0,0,0-.941,4.167.213.213,0,0,0,.016.09.347.347,0,0,0,.056.077.21.21,0,0,0,.083.051.272.272,0,0,0,.1.026h1.518a.242.242,0,0,0,.25-.231,8.743,8.743,0,0,1,2.8-6.161,9.971,9.971,0,0,1,14.35,0,8.742,8.742,0,0,1,2.8,6.161.251.251,0,0,0,.26.231h1.51a.273.273,0,0,0,.1-.026.211.211,0,0,0,.083-.051.3.3,0,0,0,.056-.077.234.234,0,0,0,.018-.09A10.731,10.731,0,0,0,563.245,1335.259Zm-11.058-6.718a6.781,6.781,0,0,1-4.276-1.732,5,5,0,0,1-1.61-3.666,4.942,4.942,0,0,1,1.51-3.665,6.67,6.67,0,0,1,4.376-1.917,6.854,6.854,0,0,1,4.534,1.917,4.8,4.8,0,0,1,1.35,3.665,4.99,4.99,0,0,1-1.6,3.666A6.8,6.8,0,0,1,552.187,1328.54Z",
    transform: "translate(-540.188 -1315.67)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneHead);
export default __webpack_public_path__ + "static/media/OneHead.bfd5b2b946e5708bd20aafdd74d45d84.svg";
export { ForwardRef as ReactComponent };